// States where access to Side/Community Listings is restricted to only active listings
export const ACTIVE_SIDE_LISTINGS_ONLY_STATES = new Set([
  'KY',
  'NC',
  'OR',
  'WA',
]);
